export default {"src":"/_next/static/media/Lazio.e8078e2f.svg","height":168,"width":250,"blurWidth":0,"blurHeight":0};